import { IServiceProgramObject } from '../types/service-program'
import { serverApi } from '../utils/request'
import Paths from '../utils/paths'
import { normalize, schema } from 'normalizr'

class ServiceProgramService {
  private programServiceSchema = new schema.Entity('programs')

  public async getAll(): Promise<{ [key: string]: IServiceProgramObject }> {
    try {
      const result = await serverApi.get(Paths.serviceProgramBaseUrl)
      const normalized = normalize(result.data, [this.programServiceSchema])
      return normalized.entities.programs
    } catch (e) {
      throw e.data
    }
  }

  public async createOne(name: string): Promise<IServiceProgramObject> {
    const result = await serverApi.post<IServiceProgramObject>(Paths.serviceProgramBaseUrl, { name })
    return result.data
  }

  public async updateOne(serviceProgram: IServiceProgramObject): Promise<IServiceProgramObject> {
    const result = await serverApi.put<IServiceProgramObject>(Paths.serviceProgramBaseUrl, serviceProgram)
    return result.data
  }

  public async removeOne(id: string): Promise<void> {
    const result = await serverApi.delete<void>(`${Paths.serviceProgramBaseUrl}/${id}`)
    return result.data
  }
}

const serviceProgramService = new ServiceProgramService()
export { serviceProgramService }



// WEBPACK FOOTER //
// ./src/services/ServiceProgram.ts